import { render, staticRenderFns } from "./AsesorVerificacionesNotificaciones.vue?vue&type=template&id=5f0e1d22"
import script from "./AsesorVerificacionesNotificaciones.vue?vue&type=script&lang=js"
export * from "./AsesorVerificacionesNotificaciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports